import ResourcesContentAccordionContainer from './container'
export default ResourcesContentAccordionContainer
